import styled from 'styled-components';

const StyledRow = styled.div<{ $noBorder?: boolean; $smallPadding?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: ${(props) => (props.$smallPadding ? '0.25rem 0' : '0.75rem 0')};
  ${(props) => (props.$noBorder ? '' : `border-bottom: 1px solid ${props.theme.color.borderColor}`)};
`;

const StyledPersonIndicator = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding-right: 1rem;
`;

const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 7px;
`;

export { StyledRow, StyledPersonIndicator, StyledImage };
